<template>
  <div id="Lobby">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Lobby',
};
</script>

<style>
  .bg {
    /* The image used */
    background-image: url("../public/background_rf.jpg") !important;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
